import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';

import AirButton from '../../../../../common/components/AirButton';

import './AssignRouteTask.css';
import { AssignIcon, CloseIcon } from '../../../../../common/icons';
import {Checkbox, Input, Modal, Select} from 'antd';
import AirModalTitlebar from '../../../../../common/components/AirModalTitlebar';

@inject('translationsStore', 'routeTaskStore', 'commonStore', 'driversStore')
@observer
export default class AssignRouteTask extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      visibleCantAssign: false,
    };
  }

  show = () => {
    this.props.record.status === 'closed' ? this.setState({ visibleCantAssign: true }) : this.setState({ visible: true, driverId: this.props.record.driverId });
  };

  hide = () => {
    this.setState({ visibleCantAssign: false, visible: false, emailText: undefined, smsText: undefined, driverId: undefined, checkedEmail: false, checkedSms: false });
  };

  onSubmit = () => {
    const { driverId, smsText, emailText, checkedEmail, checkedSms } = this.state;
    const { commonStore, routeTaskStore, record } = this.props,
      taskId = record.id;

    if (driverId === 'unassign') {

      commonStore.setLoading(true);
      routeTaskStore.unAssign(taskId).finally(() => {
        commonStore.setLoading(false);
        this.hide();
      });
    } else {

      let assignBody = { driverId };

      if (checkedSms && smsText) {
        assignBody.smsText = smsText;
      }

      if (checkedEmail && emailText) {
        assignBody.emailText = emailText;
      }

      commonStore.setLoading(true);
      routeTaskStore.assign(taskId, assignBody).finally(() => {
        commonStore.setLoading(false);
        this.hide();
      });
    }
  };

  render() {
    const { translationsStore, driversStore } = this.props,
      { visible, visibleCantAssign, emailText, driverId, smsText } = this.state;

    return (
      <Fragment>
        <AssignIcon onClick={() => this.show()} />
        <Modal className={'AirModalTitlebar'} centered={true} onCancel={this.hide} visible={visible} width={'450px'} footer={false} closable={false}>
          <div className="title">{translationsStore.translate('routePlanning.assignRoute.modal.title')}</div>
          <div className="close">
            <CloseIcon onClick={this.hide} />
          </div>
          <div className="content">
            <div className={'AssignRouteTask Container'}>
              <a className={'AssignRouteTask SubTitleLabel'}>{translationsStore.translate('routePlanning.assignRoute.modal.assignTo')}</a>
              <Select
                value={driverId || 'unassign' || []}
                onChange={value => this.setState({driverId: value})}
              >
                <Select.Option
                  value={'unassign'}>{translationsStore.translate('routePlanning.assignRoute.modal.unAssignLabel')}</Select.Option>
                {driversStore.drivers.filter(driver => driver.cars && driver.cars.length > 0).map(driver => <Select.Option
                  key={driver.id} value={driver.id}>{`${driver.name} ${driver.surname}`}</Select.Option>)}
              </Select>
              <Checkbox onChange={e => this.setState({checkedSms: e.target.checked})}>
                <a className={'AssignRouteTask CheckboxLabel'}>{translationsStore.translate('routePlanning.assignRoute.modal.checkboxSms')}</a>
              </Checkbox>
              <Input
                placeholder={translationsStore.translate('routePlanning.assignRoute.modal.placeholderSms')}
                value={smsText}
                onChange={(e) => this.setState({ smsText: e.target.value })}
              />
              <Checkbox onChange={e => this.setState({checkedEmail: e.target.checked})}>
                <a className={'AssignRouteTask CheckboxLabel'}>{translationsStore.translate('routePlanning.assignRoute.modal.checkboxEmail')}</a>
              </Checkbox>
              <Input
                placeholder={translationsStore.translate('routePlanning.assignRoute.modal.placeholderEmail')}
                value={emailText}
                onChange={(e) => this.setState({ emailText: e.target.value })}
              />
              <div style={{ marginTop: '35px', marginBottom: '35px' }}>
                <AirButton
                  disabled={!driverId}
                  onClick={() => this.onSubmit()}
                  size="large"
                  light
                  label={translationsStore.translate('routePlanning.assignRoute.modal.buttonLabel')}
                  style={{ width: '100%' }}
                />
              </div>
            </div>
          </div>
        </Modal>
        <AirModalTitlebar
          className="CantAssignRouteTaskModal"
          width="550px"
          visible={visibleCantAssign}
          title={translationsStore.translate('routePlanning.assignRoute.cantAssignModal.title')}
          onCancel={() => this.setState({ visibleCantAssign: false })}
          onOk={() => this.setState({ visibleCantAssign: false })}
          okButton={<AirButton size="large" light label={'Ok'} />}
          buttonsStyle={{ justifyContent: 'center' }}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/RouteTaskDashboard/RouteTaskTable/AssignRouteTask/AssignRouteTask.js